export abstract class AppSettings {
  public static readonly NUMBER_OF_ITEMS_IN_HISTORY = 12;
}

export enum IdleState {
  IDLE = 'idle',
  NOT_IDLE = 'not_idle',
  TIMED_OUT = 'timed_out',
  UNKNOWN = 'unknown'
}
